import React from 'react';

export default function PaginationControls({ page, totalPages, total, totalLabel, setPage }) {
  return (
    <div className="pagination">
      <span className="pagination__info">
        {total} {totalLabel}
        {total === 1 ? '' : 's'}
      </span>
      <div className="pagination__controls">
        <button
          className="pagination__btn"
          disabled={page <= 1}
          onClick={() => setPage((p) => Math.max(1, p - 1))}
        >
          ← Previous
        </button>
        <span className="pagination__page">
          Page <span className="pagination__current">{page}</span>
          <span className="pagination__separator"> / </span>
          <span className="pagination__total">{totalPages}</span>
        </span>
        <button
          className="pagination__btn"
          disabled={page >= totalPages}
          onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
        >
          Next →
        </button>
      </div>
    </div>
  );
}
